<template>
  <div id="EmbedAuthStatus">
    <template v-if="embedAuthError">
      <p class="embed-auth-message embed-auth-title">
        Something went wrong signing you in.
      </p>
      <p class="embed-auth-message">
        We weren't able to complete the sign-in process.
      </p>
      <b-button class="embed-auth-retry" @click="retry">Retry</b-button>
    </template>
    <template v-else>
      <Loader />
      <p class="embed-auth-message">Connecting you to your session…</p>
    </template>
  </div>
</template>
<script>
import Loader from "@/components/Loader";
import EventBus from "@/helpers/eventbus";

export default {
  name: "EmbedAuthStatus",
  components: { Loader },
  computed: {
    embedAuthError() {
      return this.$store.getters.embedAuthError;
    },
  },
  methods: {
    retry() {
      EventBus.$emit("retryEmbedAuth");
    },
  },
};
</script>
<style scoped lang="less">
#EmbedAuthStatus {
  max-width: 50%;
  margin: auto;
  text-align: center;

  .embed-auth-message {
    color: #616b75;
    font-size: 1.8rem;
  }

  .embed-auth-title {
    font-family: "DMSans Bold", inherit;
    font-size: 2rem;
  }

  .embed-auth-retry {
    font-size: 1.6rem;
    margin-top: 10px;
    letter-spacing: normal;
  }
}
</style>
